/* eslint-disable no-undef */
import 'react-dates/initialize'; // necessary for latest version
import React, {PureComponent} from 'react'

import {DateRangePicker, isInclusivelyBeforeDay} from 'react-dates'
import {VERTICAL_ORIENTATION, HORIZONTAL_ORIENTATION} from 'react-dates/constants'
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment'

import styles from './DatePicker.scss'

export default class SearchFormDates extends PureComponent {
  state = {
    focusedInput: null,
    startDate: null,
    endDate: null
  }

  componentWillMount() {
    const {from, to} = this.props

    this.setState({
      startDate: from ? from : null,
      endDate: to ? to : null
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.from == null && nextProps.to == null) {
      // Clear the dates.
      this.setState({
        startDate: null,
        endDate: null
      })
    }
  }

  handleDatesChange = ({startDate, endDate}) => {
    this.setState({startDate, endDate}, () => {
      if (this.state.focusedInput === null) {
        this.props.onFilter({
          from: this.state.startDate ? this.state.startDate : null,
          to: this.state.endDate ? this.state.endDate : null
        })
      }
    })
  }

  handleDateInputFocusChange = focusedInput => {
    this.setState({focusedInput})
  }

  render() {
    const isSmallDevice = window.matchMedia('(max-width: 767px)').matches
    const orientation = isSmallDevice ? VERTICAL_ORIENTATION : HORIZONTAL_ORIENTATION

    return (
        <div className={styles.fullWidthCalendar}>
          <DateRangePicker
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              onDatesChange={this.handleDatesChange}
              focusedInput={this.state.focusedInput}
              onFocusChange={this.handleDateInputFocusChange}
              startDatePlaceholderText={'From'}
              endDatePlaceholderText={'To'}
              minimumNights={0}
              orientation={orientation}
              withFullScreenPortal={orientation === VERTICAL_ORIENTATION}
              hideKeyboardShortcutsPanel
              showClearDates
              startDateId="startDate"
              endDateId="startDate"
              displayFormat={() => "DD.MM.YYYY"}
              isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
          />
        </div>
    )
  }
}
